var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[(_vm.currentExam)?_c('exam-component',{attrs:{"exam":_vm.currentExam}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }